module.exports = __webpack_public_path__ + "static/img/company_history_shulin2020.561cf8fe.jpg";